<template>
    <div class="tilda_fields" v-if="order_fields.length > 0">
        <div class="form-group mt-2" v-for="field in order_fields">
            <label class="form-label" for="advanced_name">
                {{field.name}}
            </label>

            <div class="input-group flex-nowrap">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fal  fa-typewriter fs-xl" ></i>
                    </span>
                </div>
                <input id="advanced_name" type="text" class="form-control" v-model="field.val">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "sendpulse_fields_tab",
    props : {
        location : {
            type : Object
        }
    },

    computed : {
        order_fields : {
            get() {
                if(this.location.hasOwnProperty("order_fields")) {
                    return this.location.order_fields;
                }

                return [];
            },
            set(val) {

            }
        }
    }
}
</script>

